import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=2fc40d32&scoped=true&"
import script from "./InputMask.vue?vue&type=script&lang=js&"
export * from "./InputMask.vue?vue&type=script&lang=js&"
import style0 from "./InputMask.vue?vue&type=style&index=0&id=2fc40d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc40d32",
  null
  
)

export default component.exports